import React, { useState, useEffect } from 'react';
import FeedbackIcon from './FeedbackIcon';
import { feedback, rating as ratingService } from '../../../AxiosRtk/Feedback';
import LoadingIndicator from '../../../../../setup/Loader/LoaderIndicator';
import useLangTranslation from '../../../../customHooks/languageProvider';
import { AlertModal } from '../../../../../setup/alert/swalAlert';
import { alertIconType } from '../../../../../setup/alert/iconTypes';
import SuccessMessage from '../../modals/SuccessMessage';

const Feedback = ({ checkSubsciption }) => {
  const [rating, setRating] = useState(0);
  const [feedbackData, setFeedbackData] = useState(null);
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(false);
  const [loader, setLoader] = useState(false);
  const { getLangTranslation } = useLangTranslation();
  const [successLoad, setSuccessLoad] = useState(false);
  const closeModal = () => {
    setSuccessLoad(false);
  }

  function submitFeedbackApi(payload) {
    feedback(payload)
      .then((res) => {
        setSuccessLoad(true);
        ratingApi();
      })
      .catch((err) => {
        console.log("feedback catch error ==>>", err?.response?.data?.message)
        AlertModal(err?.response?.data?.message, alertIconType?.errorIcon, true);
      })
      .finally(() => {
        setLoader(false);
      })
  }

  function ratingApi() {
    ratingService()
      .then((res) => {
        setFeedbackData(res?.data?.result[0]);
        setRating(res?.data?.result[0]?.Rating);
        if (Object.keys(res?.data?.result[0])?.length > 0) {
          setIsFeedbackSubmitted(true);
        } else {
          setIsFeedbackSubmitted(false);
        }
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message)
      })
  }

  useEffect(() => {
    ratingApi()
  }, [])

  function handleSubmit() {
    if(!checkSubsciption()){
      return;
    }
    let flag = true;
    if (rating < 0) {
      flag = false;
    }

    if (!feedbackData) {
      flag = false;
    }

    if (!flag) {
      return;
    }
    const payload = {
      rating: rating,
      message: feedbackData
    };
    submitFeedbackApi(payload);
  }

  return (
    <>
      <div className="content-550 mx-auto mt-6">
        <h5 className='mb-3'>{getLangTranslation('SETTINGS_DO_YOU_LIKE_KIDO', 'Do you like Kido Protect?')}</h5>
        <p className='text-small text-gray text-uppercase mb-9'>{getLangTranslation('SETTINGS_FEEDBACK_WE_LOVE', 'We love to hear from you. Tell us about your Kido Protect app experience')}</p>
        <div className="star-rating mb-9">
          <FeedbackIcon
            rating={rating}
            setRating={setRating}
          />
        </div>
        <div className="mb-6">
          <label htmlFor='taskDetail' className="form-label">{getLangTranslation('SETTINGS_FEEDBACK', 'Feedback')}</label>
          <textarea className="form-control bg-white" placeholder={getLangTranslation('SETTINGS_FEEDBACK_HINT', 'Share with us your experience..')} id="taskDetail" rows="3" value={feedbackData?.feedback_details} onChange={(e) => setFeedbackData(e.target.value)}></textarea>
        </div>
        {
          !isFeedbackSubmitted && (
            <button
              className="btn btn-primary w-100"
              type="button"
              onClick={handleSubmit}
            >
              {
                !loader ? (
                  <span className="btn-upper-case">{getLangTranslation('SEND', 'send')}</span>
                ) : (
                  <LoadingIndicator height={20} width={100} />
                )
              }
            </button>
          )
        }

      </div>
      <SuccessMessage
        showModal={successLoad}
        closeModal={closeModal}
        getLangTranslation={getLangTranslation}
        message='FEEDBACK_SUBMIT'
        value='Your feedback has been submitted'
      />
    </>
  )
}

export default Feedback